import Axios from "axios";
import { url } from "../../global";
import { filter } from "underscore";

const fetchOrderSparepartSystemReport = (filter) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'ORDERSPAREPARTSYSTEMREPORT',
            payload: Axios.get(`${url}/monitoring-order-sparepart/table`, {
                params: {
                    page: filter.page,
                    perpage: filter.perpage,
                    keyword: filter.keyword,
                    ordering: filter.ordering,
                    filter: filter.filter
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

const fetchSummary = (filter) => {
    return (dispatch, getState) => {
        dispatch({
            type: 'GET_SUMMARY',
            payload: Axios.get(`${url}/monitoring-order-sparepart/summary`, {
                params: {
                    filter: filter.filter
                },
                headers: {
                    Authorization: `Bearer ${localStorage.getItem('token')}`
                }
            })
        })
    }
}

export { fetchOrderSparepartSystemReport, fetchSummary };